'use strict';

// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export

var ReactHeight = require('./ReactHeight').default;

module.exports = ReactHeight;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-height/lib/index.js
// module id = 980
// module chunks = 0